import getConfig from 'next/config'

import { GoogleMapsSettings, MarkerClusters, Pin } from '@grandvisionhq/common'
import { Components } from '@grandvisionhq/stores-v2'

const { publicRuntimeConfig } = getConfig()
const gmKey = publicRuntimeConfig.googleMaps.apiKey ?? ''
const gmCenter = publicRuntimeConfig.googleMaps.mapCenter ?? {}

const { PreferredStorePin } = Components

const pinThemes = {
  primary: { foreground: '#ffffff', background: '#D3D800' },
  highlight: { foreground: '#ffffff', background: '#545600' },
  hovered: { foreground: '#A9AD00', background: '#ffffff' },
}

export const getGoogleMapsConfig = (): GoogleMapsSettings => ({
  apiKey: gmKey,
  defaultCenter: gmCenter,
  defaultZoom: 8,
  pin: Pin({
    themes: pinThemes,
  }),
  preferredStorePin: PreferredStorePin({
    themes: pinThemes,
  }),
  markerClusterOptions: MarkerClusters({
    theme: {
      color: '#009878',
      textColor: '#ffffff',
    },
    minimumClusterSize: 3,
    maxZoom: 10,
  }),
})
